var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.216,
    y: 108.214,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 255.9984 -106.0393)",
    style: {
      fill: "#FFE15A"
    },
    width: 295.567,
    height: 295.567
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#41479B"
    },
    cx: 256,
    cy: 256,
    r: 86.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M181.671,211.688c-4.087,6.841-7.242,14.278-9.327,22.172c48.019-3.614,119.052,9.819,164.264,53.69   c2.951-7.533,4.899-15.557,5.63-23.946C295.553,224.316,231.013,210.344,181.671,211.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M259.587,285.559l2.306,6.915l7.29,0.057c0.944,0.007,1.335,1.212,0.576,1.772l-5.864,4.33   l2.199,6.95c0.285,0.9-0.74,1.644-1.508,1.095l-5.931-4.239l-5.931,4.239c-0.768,0.549-1.792-0.196-1.508-1.095l2.199-6.95   l-5.864-4.33c-0.759-0.561-0.368-1.765,0.576-1.772l7.29-0.056l2.306-6.915C258.022,284.664,259.289,284.664,259.587,285.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M287.919,303.448l0.993,2.976l3.138,0.024c0.406,0.003,0.575,0.522,0.248,0.763l-2.524,1.864   l0.946,2.991c0.123,0.387-0.318,0.708-0.649,0.471l-2.553-1.824l-2.553,1.824c-0.33,0.236-0.771-0.084-0.649-0.471l0.946-2.991   l-2.524-1.864c-0.327-0.241-0.158-0.76,0.248-0.763l3.137-0.024l0.993-2.976C287.246,303.063,287.791,303.063,287.919,303.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M247.338,272.423l0.993,2.976l3.138,0.024c0.406,0.003,0.575,0.522,0.248,0.763l-2.524,1.864   l0.946,2.991c0.123,0.387-0.318,0.708-0.649,0.471l-2.553-1.824l-2.553,1.824c-0.33,0.236-0.771-0.084-0.649-0.471l0.946-2.991   l-2.524-1.864c-0.327-0.241-0.158-0.76,0.248-0.763l3.137-0.024l0.993-2.976C246.664,272.038,247.209,272.038,247.338,272.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M192.378,268.814l0.993,2.976l3.138,0.024c0.406,0.003,0.575,0.522,0.248,0.763l-2.524,1.864   l0.946,2.991c0.123,0.387-0.318,0.708-0.649,0.471l-2.553-1.824l-2.553,1.824c-0.33,0.236-0.771-0.084-0.649-0.471l0.946-2.991   l-2.524-1.864c-0.327-0.241-0.158-0.76,0.248-0.763l3.137-0.024l0.993-2.976C191.705,268.428,192.25,268.428,192.378,268.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M238.355,302.421l0.993,2.976l3.138,0.024c0.406,0.003,0.575,0.522,0.248,0.763l-2.524,1.864   l0.946,2.991c0.123,0.387-0.318,0.708-0.649,0.471l-2.553-1.825l-2.553,1.825c-0.33,0.236-0.771-0.084-0.649-0.471l0.946-2.991   l-2.524-1.864c-0.327-0.241-0.158-0.76,0.248-0.763l3.138-0.024l0.993-2.976C237.681,302.036,238.227,302.036,238.355,302.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M213.057,266.737l0.812,2.434l2.566,0.02c0.332,0.003,0.47,0.426,0.203,0.624l-2.064,1.524   l0.774,2.446c0.1,0.317-0.26,0.579-0.531,0.386l-2.087-1.492l-2.087,1.492c-0.27,0.193-0.631-0.069-0.531-0.386l0.774-2.446   l-2.064-1.524c-0.267-0.197-0.129-0.621,0.203-0.624l2.566-0.02l0.812-2.434C212.506,266.422,212.952,266.422,213.057,266.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M290.122,216.496l1.015,3.044l3.209,0.025c0.415,0.003,0.588,0.533,0.254,0.78l-2.581,1.906   l0.968,3.06c0.125,0.396-0.326,0.724-0.664,0.482l-2.611-1.866l-2.611,1.866c-0.338,0.242-0.789-0.086-0.664-0.482l0.968-3.06   l-2.581-1.906c-0.334-0.247-0.162-0.777,0.254-0.78l3.209-0.025l1.015-3.044C289.433,216.102,289.99,216.102,290.122,216.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M195.914,251.849l0.812,2.434l2.566,0.02c0.332,0.003,0.47,0.426,0.203,0.624l-2.064,1.524   l0.774,2.446c0.1,0.317-0.26,0.579-0.531,0.386l-2.087-1.492l-2.087,1.492c-0.27,0.193-0.631-0.069-0.531-0.386l0.774-2.446   l-2.064-1.524c-0.267-0.197-0.129-0.621,0.203-0.624l2.566-0.02l0.812-2.434C195.363,251.534,195.808,251.534,195.914,251.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M208.302,286.15l1.229,3.686l3.886,0.03c0.503,0.004,0.712,0.646,0.307,0.945l-3.126,2.308   l1.172,3.705c0.152,0.48-0.394,0.876-0.804,0.584l-3.161-2.26l-3.161,2.26c-0.409,0.293-0.955-0.104-0.804-0.584l1.172-3.705   l-3.126-2.308c-0.405-0.299-0.196-0.941,0.307-0.945l3.886-0.03l1.229-3.686C207.468,285.673,208.143,285.673,208.302,286.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M303.717,304.221l0.773,2.319l2.445,0.019c0.316,0.002,0.448,0.406,0.193,0.594l-1.967,1.452   l0.737,2.331c0.095,0.302-0.248,0.551-0.506,0.367l-1.989-1.422l-1.989,1.422c-0.258,0.184-0.601-0.066-0.506-0.367l0.737-2.331   l-1.967-1.452c-0.255-0.188-0.123-0.592,0.193-0.594l2.445-0.019l0.773-2.319C303.192,303.921,303.617,303.921,303.717,304.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M312.271,286.521l0.993,2.976l3.137,0.024c0.406,0.003,0.575,0.522,0.248,0.763l-2.524,1.864   l0.946,2.991c0.123,0.387-0.318,0.708-0.649,0.471l-2.553-1.825l-2.553,1.824c-0.33,0.236-0.771-0.084-0.649-0.471l0.946-2.991   l-2.524-1.864c-0.327-0.241-0.158-0.76,0.248-0.763l3.138-0.024l0.993-2.976C311.598,286.136,312.143,286.136,312.271,286.521z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/br.8341921fb937cc1f4d5db34eac529267.svg";
export { ForwardRef as ReactComponent };